// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDhOzXl929SsnGUUbyBMI2AvfNKRofOiRs",
  authDomain: "kyk-compass.firebaseapp.com",
  projectId: "kyk-compass",
  storageBucket: "kyk-compass.firebasestorage.app",
  messagingSenderId: "669611572267",
  appId: "1:669611572267:web:e7232bc681b7fb52423e6e"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };

